import { useEffect, useMemo, useState } from "react";
import {AppBar, MenuItem, Select, Stack, styled, Typography} from "@mui/material";
import DataTable from "react-data-table-component";
import { Circular } from "../../components/Circular/Circular";
import connectTopLine from "../../components/HOC/connectTopLine";
import { toastApiError } from "../../utils/toastApiError";
import { useReferralLink } from "../../hooks/useReferralLink";
import { subAffiliationApi } from "../../api/subaffiliationApi";
import { httpApi } from "../../api/httpApi";

const months = [
  { text: "January", value: "01" },
  { text: "February", value: "02" },
  { text: "March", value: "03" },
  { text: "April", value: "04" },
  { text: "May", value: "05" },
  { text: "June", value: "06" },
  { text: "July", value: "07" },
  { text: "August", value: "08" },
  { text: "September", value: "09" },
  { text: "October", value: "10" },
  { text: "November", value: "11" },
  { text: "December", value: "12" },
];

// FIXME use mui calendar
const years = {
  2020: "2020",
  2021: "2021",
  2022: "2022",
  2023: "2023",
  2024: "2024",
  2025: "2025",
  2026: "2026",
};

const StyledRoot = styled("div")(({ theme }) => ({
  flexGrow: 1,
  backgroundColor: theme?.palette?.background?.paper, // FIXME why is palette not defined?
  margin: "0 -15px",
  paddingTop: "20px"
}));

const StyledRow = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
}));

const StyledAppBar = styled(AppBar)(({ theme }) => ({
  backgroundColor: "#5361f5",
}));

const StyledRefCode = styled(Typography)(({ theme }) => ({
  padding: "15px",
  marginBottom: "0px",
  textAlign: "center",
}));

const StyledTotal = styled(Typography)(({ theme }) => ({
  padding: "15px",
  marginBottom: "0px",
}));

const StyledSelect = styled(Select)(({ theme }) => ({
  marginRight: "15px",
  minWidth: "100px",
}));

const columns = [
  { name: "SubAffiliate", selector: (row) => row.subAffiliateEmail, sortable: true, width: 500 },
  { name: "Commission", selector: (row) => row.subAffiliationCommission, sortable: true, width: 200 },
  { name: "FTDs", selector: (row) => row.ftds, sortable: true },
];

const Subaffilation = () => {
  const [loading, setLoading] = useState(false);
  const [mySubs, setMySubs] = useState([]);
  const [link, setLink] = useState({});
  const [month, setMonth] = useState(new Date().getMonth() + 1);
  const [year, setYear] = useState(new Date().getFullYear());

  useEffect(() => {
    setLoading(true);
    httpApi
        .doGet('/api/v3/reports/subaffiliation/index')
        .then((response) => setLink(response))
        .catch(toastApiError)
        .finally(() => setLoading(false))
  }, []);

  useEffect(() => {
    setLoading(true);
    subAffiliationApi.getSubAffiliationReport(year, month)
        .then((response) => setMySubs(response.reports))
        .catch(toastApiError)
        .finally(() => setLoading(false));
  }, [month, year]);

  const referralLink = useReferralLink(link.referralCode);

  const getTotalCommission = useMemo(() => {
    return mySubs.reduce((sum, item) => sum + item.subAffiliationCommission, 0).toFixed(2);
  }, [link, mySubs]);

  return (
    <StyledRoot>
      <StyledRow>
        <StyledRefCode variant="h5" gutterBottom>
          Your referral link: <a href={ referralLink }>{ referralLink }</a>
        </StyledRefCode>
        <div className={{/*classes.filters*/ }}>
          <StyledSelect
            labelId="demo-simple-select-label"
            value={month}
            onChange={(e) => setMonth(e.target.value)}
          >
            {months.map((month, index) => (
              <MenuItem key={month.value} value={index + 1}>
                {month.text}
              </MenuItem>
            ))}
          </StyledSelect>
          <StyledSelect
            labelId="demo-simple-select-label"
            value={year}
            onChange={(e) => setYear(e.target.value)}
          >
            {Object.entries(years).map(([id, year]) => (
              <MenuItem key={id} value={id}>
                {year}
              </MenuItem>
            ))}
          </StyledSelect>
        </div>
      </StyledRow>
      <StyledAppBar sx={{ mt: 4 }} position="static">
        <Stack flexDirection="row" justifyContent="space-between">
          <StyledTotal variant="h6" gutterBottom>
            Your total commission for <b>{months[month - 1].text}</b> <b>{year}</b> is{" "}
            <b>€{getTotalCommission}</b>
          </StyledTotal>
          <StyledTotal variant="h6" gutterBottom>
            Your Commission Percentage: {link.subAffiliationPercentage && link.subAffiliationPercentage * 100} %
          </StyledTotal>
        </Stack>
      </StyledAppBar>
      <StyledAppBar position="static">
        <DataTable
          pagination
          data={mySubs}
          columns={columns}
          progressPending={loading}
          progressComponent={<Circular />}
          paginationComponentOptions={{ noRowsPerPage: true }}
        />
      </StyledAppBar>
    </StyledRoot>
  );
};

export default connectTopLine(false, false, Subaffilation);
